// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// SCOPING FROM REPO SCHEMA
/////////////////////////////////////////

export const ScopingFromRepoSchema = z.object({
  id: z.string(),
  tenantId: z.string().nullable(),
  applicationId: z.string(),
  repositoryName: z.string(),
  description: z.string(),
  serverSideLanguages: z.string().array(),
  frameworkNames: z.string().array(),
  clientSideTechnologies: z.string().array(),
  hasSinglePageApp: z.boolean().nullable(),
  usesApi: z.boolean().nullable(),
  numberOfApiEndpoints: z.number().int().nullable(),
  hasApiDocs: z.boolean().nullable(),
  authenticationMechanisms: z.string().array(),
  usesDatabase: z.boolean().nullable(),
  databaseTechnologies: z.string().array(),
  usesOrm: z.boolean().nullable(),
  ormNames: z.string().array(),
  dataTypes: z.string().array(),
  userRoles: z.string().array(),
  roleDescriptions: z.string().array(),
  rbacType: z.string().nullable(),
  hasSelfRegistration: z.boolean().nullable(),
  externalServicesUsed: z.string().array(),
  cloudProviderHints: z.string().array(),
  usesCi: z.boolean().nullable(),
  usesCdn: z.boolean().nullable(),
  environmentFiles: z.string().array(),
  configFiles: z.string().array(),
  testFilesPresent: z.boolean().nullable(),
  technologyStack: z.string().array(),
  containerization: z.boolean().nullable(),
  containerFiles: z.string().array(),
  secretsDetected: z.boolean().nullable(),
  secretsFiles: z.string().array(),
  ciCdFiles: z.string().array(),
  codeQualityTools: z.string().array(),
  packageManagers: z.string().array(),
  thirdPartyDependencies: z.string().array(),
  licenseFiles: z.string().array(),
  readmeFiles: z.string().array(),
  deploymentFiles: z.string().array(),
  monitoringTools: z.string().array(),
  loggingLibraries: z.string().array(),
  errorTrackingTools: z.string().array(),
  apiSpecFiles: z.string().array(),
  authDetails: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type ScopingFromRepo = z.infer<typeof ScopingFromRepoSchema>

export default ScopingFromRepoSchema;
